export const ethicsFormResetList = [
    'isNeedEditForm',
    'isPhase',
    'isTools',
    'numPhase',
    'faculty',
    'IRB',
    'projectNameTH',
    'projectNameEN',
    'langTH',
    'langEN',
    'isCertificatePaperList',
    'researcherType',
    'researcherType',
    'educationLevel',
    'titleName',
    'otherTitleNameTH',
    'otherTitleNameEN',
    'isDr',
    'academicPosition',
    'otherAcademicPositionTH',
    'otherAcademicPositionEN',
    'nameTH',
    'nameEN',
    'homePhone',
    'fax',
    'mobilePhone',
    'email',
    'researchProjectSummaryTH',
    'researchProjectSummaryEN',
    'projectAdvisor',
    'projectAdvisorEmail',
    'projectAdvisorEmailReserve',
]
